import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/clasificadores-de-tipos-de-cargo-portal/';

/**
 * GET Clasificadores De Tipos De Cargo
 * @returns {Promise<Array<object>>}
 */
export const getClasificadoresDeTiposDeCargo = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Clasificador De Tipos De Cargos
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getClasificadorDeTiposDeCargos = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Clasificador De Tipos De Cargos
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postClasificadorDeTiposDeCargos = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Clasificador De Tipos De Cargos
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchClasificadorDeTiposDeCargos = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Clasificador De Tipos De Cargos
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteClasificadorDeTiposDeCargos = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
